import {
  FETCH_DASHBOARD_DATA_SUCCESS,
  FETCH_DASHBOARD_DATA_FAILURE,
  FETCH_BY_GUARD_SUCCESS,
  FETCH_BY_GUARD_FAILURE,
  FETCH_BY_REGION_SUCCESS,
  FETCH_BY_REGION_FAILURE,
} from "./actionTypes";

const initialState = {
  data: null,
  regionData: null,
  guardData: null,
  error: null,
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DASHBOARD_DATA_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        error: null,
      };
    case FETCH_DASHBOARD_DATA_FAILURE:
      return {
        ...state,
        data: null,
        error: action.error,
      };
    case FETCH_BY_GUARD_SUCCESS:
      return {
        ...state,
        guardData: action.payload,
        error: null,
      };
    case FETCH_BY_GUARD_FAILURE:
      return {
        ...state,
        guardData: null,
        error: action.error,
      };
    case FETCH_BY_REGION_SUCCESS:
      return {
        ...state,
        regionData: action.payload,
        error: null,
      };
    case FETCH_BY_REGION_FAILURE:
      return {
        ...state,
        regionData: null,
        error: action.error,
      };
    default:
      return state;
  }
};

export default dashboardReducer;
